import httpClient from '~/lib/http-client';

export async function apiReadSandboxFile(chatId: string, path: string): Promise<string> {
  const { data } = await httpClient.get<{ success: boolean; content: string }>(`/api/sandbox/${chatId}/files`, {
    params: { path },
  });

  return data.content;
}

export async function apiWriteSandboxFile(chatId: string, path: string, content: string): Promise<void> {
  await httpClient.post(`/api/sandbox/${chatId}/files`, { path, content });
}

export interface SandboxTreeEntry {
  /** Absolute pod path, e.g. `/home/project/frontend/src/App.tsx`. */
  path: string;
  type: 'file' | 'folder';
}

/**
 * The workspace file tree, in one call.
 *
 * The file tree used to come only from the pod agent's event log replayed over
 * the socket, and supervisord truncates that log at 1 MB with no backups — so
 * after a page refresh a 24k-file workspace came back with one entry. This is
 * the authoritative starting picture; the socket still carries live deltas.
 *
 * Paths only. Content is read per file when one is opened.
 */
export async function apiGetSandboxTree(chatId: string): Promise<SandboxTreeEntry[]> {
  const { data } = await httpClient.get<{ success: boolean; entries: SandboxTreeEntry[] }>(
    `/api/sandbox/${chatId}/tree`,
  );

  return data.entries ?? [];
}
